<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="ok()">OK</button>
  <button mat-raised-button (click)="cancel()">CANCEL</button>
</mat-dialog-actions>

